import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerService } from '../../services/customer.service';
import { ICustomer } from '../Customer/customer.class';


@Component({
    selector: 'app-manage',
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.css']
})

export class HomeComponent implements OnInit
{
    showCustomers = false;
    showCustomerDetails = false;
    showSystem = false;
    user: ICustomer = null;
    selectedCustomer: ICustomer;

    constructor(private router: Router, private userService: CustomerService)
    {
    }

    onCustomerSelected(customer: ICustomer)
    {
        this.showCustomers = false;
        this.showCustomerDetails = true;
        this.selectedCustomer = customer;
    }

    onMenu(event: string)
    {
        if (event == 'customers')
        {
            this.showCustomers = true;
            this.showCustomerDetails = false;
            this.showSystem = false;
    }
        else if (event == 'home')
        {
            this.showCustomers = false;
        }
        else if (event == 'system')
            {
                this.showCustomers = false;
                this.showCustomerDetails = false;
                this.showSystem = true;
            }
        }

    ngOnInit(): void
    {
        let str = localStorage.getItem('user');
        if (str)
        {
            this.user =  JSON.parse(str);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Home/home.component.ts